import { CompositionDetails } from "../composition-types";
import { compositionIds } from "../composition-ids";
import { RhythmPortion } from "../../rhythms/rhythm-types";

const portions: RhythmPortion[] = [
    {
        beatsPerCycle: 14,
        beatsPerMinute: 165,
        startTime: 93.25,
    },
    {
        beatsPerCycle: 14,
        beatsPerMinute: 0,
        startTime: 847,
    },
];

export const aiseLaalanPayo: CompositionDetails = {
    id: compositionIds.aiseLaalanPayo,
    rhythmSpec: {
        rhythmPortions: portions,
    },
    media: {
        youtubeVideoId: "_ygnqb5NXsA",
    },
    displayName: "Aise Laalan Payo Ree Sakhi - Guneet Kaur Ji",
    taals: ["deepchandi"],
};
